import React, { useContext } from "react";
import { Row, Col } from "react-bootstrap";
import { useQuery } from "@apollo/client";
//import { Link } from "react-router-dom";
import HeaderBox from "../reuseableComponents/headerBox";
import { GET_APP_MENU } from "../../queries/menuQrys/baseWLMenuQrys";
import SkeletonLoader from "../reuseableComponents/loaders/SkeletonLoader";
import MenuCard from "../reuseableComponents/MenuCard";
import { faCloudUploadAlt, faTable } from "@fortawesome/free-solid-svg-icons";
import ErrorHandler from "../reuseableComponents/ErrorHandler";
import { UserContext } from "../reuseableComponents/auth/UserContext";

const menuIcons = {
  LSL_FILE_UPLOAD: faCloudUploadAlt,
  LSL_WRKBK_DWNLD_LT50: faTable,
  LSL_WRKBK_DWNLD_MT50: faTable
};

const LeadServiceLineIndex = () => {
  const { user } = useContext(UserContext);
  let userRole = user.isPortalUser
    ? "isPortal"
    : user.isStaff && !user.isSysAdmin
    ? "isStaff"
    : user.isSysAdmin
    ? "sysAdmin"
    : "public";

  const { loading, error, data } = useQuery(GET_APP_MENU, { variables: { menu: "LSL", userRole: userRole } });

  if (loading || error)
    return (
      <div className="page-container lsl-index-container">
        <Row>
          <Col>
            <HeaderBox id={"gray-primary"} cypressid='lslIndexPage'>
              <h1 className="main-section-title">Lead Service Line</h1>
            </HeaderBox>
          </Col>
        </Row>
        <Row>
          <Col>
            {loading ? <SkeletonLoader width='100%' /> : ""}
            {error ? <ErrorHandler error={error} /> : ""}
          </Col>
        </Row>
      </div>
    );

  return (
    <div className="page-container lsl-index-container">
      <Row>
        <Col>
          <HeaderBox id={"gray-primary"} cypressid='lslIndexPage'>
            <h1 className="main-section-title">Lead Service Line</h1>
          </HeaderBox>
        </Col>
      </Row>
      <Row>
        {data.getAppMenu.map((module) => (
          <Col md={4} key={module.value}>
            <MenuCard icon={menuIcons[module.value]} module={module.value} route={module.route} name={module.label} />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default LeadServiceLineIndex;
